import { baseApi } from '../baseApi';
import { TournamentCalendarModel } from '../../models/tournamentCalendarModel';
import { cleanObject } from '../../utils/objectUtils';

export async function syncTournamentCalendarReq() {
  let url = '/officiating/tournament-calendar/edit/sync';
  return baseApi.get(url);
}

export async function assignCandidate(tournamentId: string) {
  let url = '/officiating/tournament-calendar/edit/candidate?';
  let queryParamsObj = cleanObject({
    tournamentId,
  });
  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.post(url + queryParams);
}

export async function removeCandidate(tournamentId: string) {
  let url = '/officiating/tournament-calendar/edit/candidate?';
  let queryParamsObj = cleanObject({
    tournamentId,
  });
  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.delete(url + queryParams);
}

export async function createUpdateTournamentReq(
  tournament: TournamentCalendarModel,
  tournamentId?: string,
) {
  let url = '/officiating/tournament-calendar/edit?';
  let queryParamsObj = cleanObject({
    tournamentId,
  });
  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.post<TournamentCalendarModel>(url + queryParams, { tournament });
}

export async function deleteTournamentReq(tournamentId: string) {
  let url = '/officiating/tournament-calendar/edit?';
  let queryParamsObj = cleanObject({
    tournamentId,
  });
  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.delete(url + queryParams);
}
